export default class Resposta {
    returnModel() {
        return {
            id: null,
            enquete: null,
            pais: null,
            empresa: null,
            divisao: null,
            localidade: null,
            usuario: null,
            hashUsuario: null,
            respostaPergunta: null,
            dataCadastro: null,
            dataExclusao: null
        }
    }
}